// LRU bookkeeping for the IndexedDB matte cache (CODE_REVIEW S15). A matte is ~2.8 MB at 2048 px; without
// a cap the store grew by every photo ever cut out, and under disk pressure the browser may evict the
// whole origin (in fallback mode that includes every sidecar). Pure, so it is unit-tested.

/** At most this many mattes stay in IndexedDB (~280 MB); the folder's .epb.mask.png files remain. */
export const MATTE_CACHE_MAX = 100;
export const LRU_KEY = '__lru';

export type LruIndex = { key: string; t: number }[];

/** Marks `key` as used at `now`; returns the new index and the keys to delete (oldest first). */
export function touchLru(
  index: LruIndex,
  key: string,
  now: number,
  max = MATTE_CACHE_MAX,
): { index: LruIndex; evict: string[] } {
  const next = index.filter((e) => e.key !== key);
  next.push({ key, t: now });
  next.sort((a, b) => a.t - b.t);
  const evict = next.length > max ? next.splice(0, next.length - max).map((e) => e.key) : [];
  return { index: next, evict };
}
